/**
 * Excel項目(読取項目)・入札会専用（ExcelItemsConstの姉妹定数・design-sale-bulk-upload.md §2-a・22列）
 */
export const ExcelItemsSaleConst =
{
  /** 売手コード[A列] */
  SellerCode: "0",
  /** 生産者コード[B列] */
  FarmerCode: "1",
  /** 生産者名[C列] */
  FarmerName: "2",
  /** 生産者公開有無[D列] */
  IsFarmerHidden: "3",
  /** 茶区分[E列] */
  TeaCategoryCode: "4",
  /** 茶期[F列] */
  TeaSeasonCode: "5",
  /** 茶種[G列] */
  TeaTypeCode: "6",
  /** 荷印[H列] */
  Brand: "7",
  /** 品種名[I列] */
  VarietyCode: "8",
  /** その他品種名[J列] */
  VarieryNameFree: "9",
  /** 栽培区分[K列] */
  CaltivationCategoryCode: "10",
  /** 生産履歴[L列] */
  ProductionHistory: "11",
  /** 製法区分[M列] */
  ManufacturingMethod: "12",
  /** 容量(kg)①[N列] */
  Capacity1: "13",
  /** 本数①[O列] */
  Quantity1: "14",
  /** 容量(kg)②[P列] */
  Capacity2: "15",
  /** 本数②[Q列] */
  Quantity2: "16",
  /** 最低落札値[R列] */
  BidMinPrice: "17",
  /** 特記事項（既存のBikoと同一・S列） */
  Biko: "18",
  /** 備考1（入札会専用・T列） */
  SaleBiko1: "19",
  /** 備考2（入札会専用・U列） */
  SaleBiko2: "20",
  /** 備考3（入札会専用・V列） */
  SaleBiko3: "21",
} as const;
export type ExcelItemsSaleType = typeof ExcelItemsSaleConst[keyof typeof ExcelItemsSaleConst]

/**
 * 入札会専用Excelのデータ列見出し（1行目・データ列のみ・総量等の表示列は含まない）。
 * アップロード時に選択中の出品区分と実際のファイルが一致しているかの判定に使う。
 */
export const ExcelItemsSaleExpectedHeaders = [
  "売手コード", "生産者コード", "生産者名", "生産者公開有無",
  "茶区分", "茶期", "茶種", "荷印", "品種名", "その他品種名",
  "栽培区分", "生産履歴", "製法区分",
  "容量 (kg)①", "本数①", "容量 (kg)②", "本数②",
  "最低落札値", "特記事項", "備考1", "備考2", "備考3",
] as const;

/**
 * 入札会専用出品情報一括登録エクセルのファイル名称
 */
export const templateExcelSaleFileName = "入札会専用出品情報一括登録_ひな形.xlsx";
/**
 * 入札会専用出品情報一括登録の結果エクセルのファイル名称
 */
export const resultExcelSaleFileName = "入札会専用出品情報一括登録_結果";
